import { trans } from '@spotahome/soyuz/client';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_DEPOSIT_PROTECTION_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import FeatureBox from './FeatureBox';
import Point1Illustration from './Illustrations/Point1Illustration';
import Point2Illustration from './Illustrations/Point2Illustration';
import Point3Illustration from './Illustrations/Point3Illustration';

import styles from './DepositProtectionModal.module.scss';

const DEPOSIT_POINTS = [
  {
    title: trans('deposit-protected.modal.point-1.title'),
    content: trans('deposit-protected.modal.point-1.content'),
    renderImage: () => <Point1Illustration />
  },
  {
    title: trans('deposit-protected.modal.point-2.title'),
    content: trans('deposit-protected.modal.point-2.content'),
    renderImage: () => <Point2Illustration />
  },
  {
    title: trans('deposit-protected.modal.point-3.title'),
    content: trans('deposit-protected.modal.point-3.content'),
    renderImage: () => <Point3Illustration />
  }
];

const DepositProtectionModal = () => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_DEPOSIT_PROTECTION_MODAL
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      size="medium"
      className={styles['deposit-protection-modal']}
    >
      <ModalHeader
        className={styles['deposit-protection-modal__header']}
        onRequestClose={handleModalClose}
        label={trans('listing.labels.deposit-protected.title')}
      />
      <ModalBody className={styles['deposit-protection-modal__body']}>
        <p className={styles['deposit-protection-modal__description']}>
          {trans('deposit-protected.modal.description')}
        </p>
        <div className={styles['deposit-protection-modal__features']}>
          {DEPOSIT_POINTS.map(point => (
            <FeatureBox
              key={point.title}
              title={trans(point.title)}
              content={trans(point.content)}
              renderImage={point.renderImage}
            />
          ))}
        </div>
      </ModalBody>
    </Modal>
  ) : null;
};

export default DepositProtectionModal;
